module.exports = __webpack_public_path__ + "media/images/logo_note_write_black-ee9e6a91a9ce2e27cba3661cf8ac7c9d.png";